import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

const fileUploadAdapter = createEntityAdapter({});
const initialState = fileUploadAdapter.getInitialState();

export const fileUploadApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getFile: builder.query({
            query: ({ folder, filename }) => ({
                url: `/files/${folder}/${filename}`,
                method: 'GET',
                responseHandler: (response) => response.blob(), // Get the file as a blob
            }),
        }),         
        uploadFile: builder.mutation({
            query: ({ formData, folder, tag }) => ({
                url: `/upload/upload/${folder}`, // Match the backend route
                method: 'POST',
                body: formData,
            }),
            invalidatesTags: (result, error, { tag }) => [
                { type: 'File', id: 'LIST' }, // Always invalidate the file list
                ...(tag ? [{ type: tag.type, id: tag.id }] : []), // Dynamically invalidate based on the tag
            ],
        }),

        deleteFile: builder.mutation({
            query: ({ folder, filename }) => {
                return {
                    url: `/upload/delete/${folder}/${filename}`,
                    method: 'DELETE'
                };
            },
            invalidatesTags: [{ type: 'File', id: 'LIST' }]
        }),

        replaceFile: builder.mutation({
            query: ({ folder, filename, file }) => {
                const formData = new FormData();
                formData.append('file', file);
        
                return {
                    url: `/upload/replace/${folder}/${filename}`,
                    method: 'POST',
                    body: formData,
                };
            },
            invalidatesTags: [{ type: 'File', id: 'LIST' }]
        }),
        combineFiles: builder.mutation({
            query: ({ folder, pdfFiles, outputFilename, convertToEpub }) => ({
                url: `/upload/combine/${folder}`,
                method: "POST",
                body: {
                    pdfFiles,
                    outputFilename,
                    convertToEpub,
                },
            }),
            invalidatesTags: [{ type: "File", id: "LIST" }],
        }),
        
    }),
});

export const {
    useUploadFileMutation,
    useDeleteFileMutation,
    useReplaceFileMutation,
    useGetFileQuery,
    useCombineFilesMutation,
} = fileUploadApiSlice;
